import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import { message } from 'antd';
import qs from 'query-string';
import { MSG } from 'commons/constants';

const useBillPublicDetail = (id: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [billInfo, setBillInfo] = useState<BillInfoDto>();
  const [billItems, setBillItems] = useState<BillItemInfoDto[]>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading } = useQuery(
    [endpoints.bill.info.public, {id: id}],
    () =>
      fetcher.bill.postBillPublicInfo({id: id}),
    {
      onSuccess: (res: BillInfoResDto) => {
        switch (res.code) {
          case 200:
            setBillInfo(res.result?.info);
            setBillItems(res.result?.items);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );


  const { mutate: billUpdate, isSuccess: updateSuccess } = useMutation(
    [endpoints.bill.info.update],
    fetcher.bill.postBillInfoUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: billStatusUpdate, isSuccess: updateStatusSuccess } = useMutation(
    [endpoints.bill.info.update_status],
    fetcher.bill.postBillInfoUpdateStatus,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  return { billInfo, billItems, updateSuccess, billUpdate, updateStatusSuccess, billStatusUpdate };
};

export default useBillPublicDetail;
